




































































































































import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import IgCheckoutModal from './components/IgCheckoutModal.vue';

const { mapState, mapActions, mapMutations } = createNamespacedHelpers('plans');

export default Vue.extend({
  name: 'page-plan',
  data() {
    return {
      showCheckout: false,
      specs: [
        {
          label: this.$t('pagePlan.specs.maxModules.label'),
          tooltip: this.$t('pagePlan.specs.maxModules.tooltip'),
          tooltipLarge: true,
          icon: 'question-circle',
          fieldRestriction: 'maxIntegration',
          isFinance: true,
        },
        {
          label: this.$t('pagePlan.specs.maxRequest.label'),
          tooltip: this.$t('pagePlan.specs.maxRequest.tooltip'),
          tooltipLarge: true,
          icon: 'question-circle',
          fieldRestriction: 'maxRequest',
          isFinance: true,
        },
        {
          label: this.$t('pagePlan.specs.contingency.label'),
          tooltip: this.$t('pagePlan.specs.contingency.tooltip'),
          tooltipLarge: true,
          icon: 'question-circle',
          fieldRestriction: 'hasContingency',
          isBoolean: true,
        },
        {
          label: this.$t('pagePlan.specs.erp.label'),
          tooltip: this.$t('pagePlan.specs.erp.tooltip'),
          tooltipLarge: true,
          icon: 'question-circle',
          fieldRestriction: 'hasErp',
          isBoolean: true,
        },
        {
          label: this.$t('pagePlan.specs.multiCd.label'),
          tooltip: this.$t('pagePlan.specs.multiCd.tooltip'),
          tooltipLarge: true,
          icon: 'question-circle',
          fieldRestriction: 'hasMultiCd',
          isBoolean: true,
        },
        {
          label: this.$t('pagePlan.specs.support.label'),
          tooltip: this.$t('pagePlan.specs.support.tooltip'),
          tooltipLarge: true,
          icon: 'question-circle',
          fieldRestriction: 'hasSupport',
          isBoolean: true,
        },
        {
          label: this.$t('pagePlan.specs.marketplace.label'),
          tooltip: this.$t('pagePlan.specs.marketplace.tooltip'),
          tooltipLarge: true,
          icon: 'question-circle',
          fieldRestriction: 'hasMarketplace',
          isBoolean: true,
        },
        {
          label: this.$t('pagePlan.specs.deploymentConsulting.label'),
          tooltip: this.$t('pagePlan.specs.deploymentConsulting.tooltip'),
          tooltipLarge: true,
          icon: 'question-circle',
          fieldRestriction: 'priceDeploymentConsulting',
          isFinance: true,
        },
        {
          label: this.$t('pagePlan.specs.daysFree.label'),
          tooltip: this.$t('pagePlan.specs.daysFree.tooltip'),
          icon: 'question-circle',
          isDaysFree: true,
        },
      ],
    };
  },
  computed: {
    ...mapState([
      'loading',
      'plans',
      'actualPlan',
    ]),
  },
  methods: {
    ...mapMutations([
      'setCheckout',
    ]),
    ...mapActions([
      'getPlans',
    ]),
    showBtnSubscribe(plan: any) {
      const isActualPlan = plan.slug === this.actualPlan.slug;
      if (this.actualPlan.migrationPlanSlug) {
        return plan.price > this.actualPlan.price && !isActualPlan;
      }

      return !isActualPlan;
    },
    choosePlan(plan: any) {
      if (plan.price < this.actualPlan.price) {
        return this.$buefy.dialog.confirm({
          title: String(this.$t('pagePlan.modalConfirmDowngrade.title')),
          message: String(this.$t('pagePlan.modalConfirmDowngrade.message')),
          confirmText: String(this.$t('pagePlan.modalConfirmDowngrade.confirm')),
          cancelText: String(this.$t('pagePlan.modalConfirmDowngrade.cancel')),
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => this.openCheckout(plan),
        });
      }

      return this.openCheckout(plan);
    },
    openCheckout(plan: any) {
      this.setCheckout({
        plan,
        product: null,
      });
      this.showCheckout = true;
    },
  },
  async beforeMount(): Promise<void> {
    await this.getPlans();
  },
  components: {
    IgCheckoutModal,
  },
});
